import React from 'react';

import { Link } from 'react-router-dom';

const LinkErrorPage = () => {
    return (
        <div className="app__message-page__container">
            <p className="semi-bold push-down-30">Page not found</p>
            <Link to="/">Go to home page</Link>
        </div>
    );
};

export default LinkErrorPage;
